import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';

let baseUrl = 'https://b316wmuwh1.execute-api.us-east-1.amazonaws.com/default/post_parentesco_benef';

class ParentescoBenef extends Component {
    
    constructor() {
        super();
        this.state = {
            datos_parentesco: []
        };
    }
    async componentDidMount() {
        await axios.post(baseUrl,{id_campana: '807365f9-8c54-4074-a32f-eeba79502478'})
        .then(response => {
            //console.log('exito al enviar POST Parentesco: ' + JSON.stringify(response.data));
            this.setState({datos_parentesco:response.data});
        })
        .catch(response => {
            console.log(response + ' error POST Parentesco')
        })

    }
    render(){
        const { datos_parentesco } = this.state;
        let parentescoList = datos_parentesco.length > 0
            && datos_parentesco.map((item, i) => {
                return (
                    <option key={item.rel_cod_relationship_benef} value={item.rel_id_benef+'-'+item.rel_cod_relationship_benef+'-'
                    +item.rel_name_relationship_benef}>{item.rel_name_relationship_benef}</option>
                )
            }, this);
        return(
            <>
            {parentescoList}
            </>
        )
    }
}
  
export default ParentescoBenef; 
